import { PayoutsApiFactory } from '@flipdish/api-client-typescript';

import { createApi } from '../../../helpers/utilities';
import { mapServerError } from '../../../services/utils/serverErrorMapper';
import { serializePayoutResponse, serializeSummaryResponse } from './helpers';
import { PayoutRequest, PayoutSummaryRequest } from './types';

const payoutApi = createApi(PayoutsApiFactory);

// #region getPayoutDetailsSummary
export async function getPayoutDetailsSummary({ appId, bankAccountId, payoutId }) {
  try {
    const response = await payoutApi.getPayout(appId, bankAccountId, payoutId);
    return response;
  } catch (incomingError) {
    const e = await mapServerError(incomingError);
    throw e;
  }
}
// #endregion

// #region getPayoutDetailsTableOrders
export async function getPayoutDetailsTableOrders({
  appId,
  bankAccountId,
  payoutId,
  page,
  limit,
  storeIdsFilter,
}) {
  try {
    const response = await payoutApi.getPayoutOrders(
      appId,
      bankAccountId,
      payoutId,
      page,
      limit,
      storeIdsFilter
    );
    return response;
  } catch (incomingError) {
    const e = await mapServerError(incomingError);
    throw e;
  }
}
// #endregion

// #region getPayoutDetailsTableRefund
export async function getPayoutDetailsTableRefund({
  appId,
  bankAccountId,
  payoutId,
  page,
  limit,
  storeIdsFilter,
}) {
  try {
    const response = await payoutApi.getPayoutRefunds(
      appId,
      bankAccountId,
      payoutId,
      page,
      limit,
      storeIdsFilter
    );
    return response;
  } catch (incomingError) {
    const e = await mapServerError(incomingError);
    throw e;
  }
}
// #endregion

// #region getPayoutDetailsTableChargebacks
export async function getPayoutDetailsTableChargebacks({
  appId,
  bankAccountId,
  payoutId,
  page,
  limit,
  storeIdsFilter,
}) {
  try {
    const response = await payoutApi.getPayoutChargebacks(
      appId,
      bankAccountId,
      payoutId,
      page,
      limit,
      storeIdsFilter
    );
    return response;
  } catch (incomingError) {
    const e = await mapServerError(incomingError);
    throw e;
  }
}
// #endregion

// #region getPayoutDetailsTableOtherCharges
export async function getPayoutDetailsTableOtherCharges({
  appId,
  bankAccountId,
  payoutId,
  page,
  limit,
  storeIdsFilter,
}) {
  try {
    const response = await payoutApi.getPayoutOtherCharges(
      appId,
      bankAccountId,
      payoutId,
      page,
      limit,
      storeIdsFilter
    );
    return response;
  } catch (incomingError) {
    const e = await mapServerError(incomingError);
    throw e;
  }
}
// #endregion

// #region getPayoutTableSummary
export async function getPayoutTableSummary({
  appId,
  startDate,
  endDate,
  bankAccountIds,
  states,
}: PayoutSummaryRequest) {
  try {
    const response = await payoutApi.getPayoutSummaries(
      appId,
      startDate.format('YYYY-MM-DDTHH:mm:ss[Z]'),
      endDate.format('YYYY-MM-DDTHH:mm:ss[Z]'),
      bankAccountIds,
      states
    );
    const serializedData = serializeSummaryResponse(response.Data);
    return serializedData;
  } catch (incomingMessage) {
    const e = await mapServerError(incomingMessage);
    throw e;
  }
}
// #endregion

// #region getPayoutTableResults
export async function getPayoutTableResults({
  appId,
  languageCode,
  startDate,
  endDate,
  page,
  limit,
  bankAccountIds,
  states,
}: PayoutRequest) {
  try {
    const response = await payoutApi.getPayouts(
      appId,
      startDate.format('YYYY-MM-DDTHH:mm:ss[Z]'),
      endDate.format('YYYY-MM-DDTHH:mm:ss[Z]'),
      page + 1,
      limit,
      bankAccountIds,
      states
    );
    const serializedData = serializePayoutResponse(response.Data, languageCode);
    return {
      result: serializedData,
      pagination: {
        page: response.Page,
        pageSize: response.Limit,
        total: response.TotalRecordCount,
      },
    };
  } catch (incomingMessage) {
    const e = await mapServerError(incomingMessage);
    throw e;
  }
}
// #endregion
